<template>
  <div class="content">
    <div class="input-box">
      <div class="form-box">
        <div class="pwd-box">
          <input class="pwd" v-model="password" placeholder="请输入密码" :type="passwordType" />
          <span class="solts" @click="switchPasswordType">
               <van-icon name="eye" v-if="passwordType==='text'" />
               <van-icon name="closed-eye" v-if="passwordType==='password'"  />
          </span>
        </div>
        <div class="btn-box">
          <van-button :disabled="isDisable" class="btn-txt" round block type="primary" @click="onSubmit">
            进入
          </van-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "roomPassword",
  data(){
    return{
      password:'',
      roomId:'',
      isDisable:false,
      passwordType: 'password',//输入框类型
    }
  },
  created() {
    this.roomId = this.$route.query.id
  },
  methods:{
    switchPasswordType() {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password'
      console.log(this.passwordType)
    },
    onSubmit(){
      if (this.password == ''){
        this.$toast('请输入密码')
      } else {
        this.isDisable = true
        //  this.$router.push({path:'/zhiBoDes',query: {id:item.id}})
        this.$router.replace({path:'/zhiBoDes',query: {id:this.roomId,pwd:this.password}})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.input-box{
  margin: 40px 24px;background: #ffffff;padding: 30px 0 40px;
  .form-box{
    padding: 20px;
  }
  .pwd-box{
    width: 100%;background: #eae9e9;display: block;height: 88px;line-height: 88px; margin-bottom: 40px;
    font-size: 28px;border-radius: 10px;position:relative;
    .solts{
      position: absolute;right: 20px;top: 10px;font-size: 32px;color: #666666;
    }
  }
  .pwd{
    width: 100%;background: #eae9e9;display: block;height: 88px;line-height: 88px; margin-bottom: 40px;
    border: none;font-size: 28px;border-radius: 10px;
  }
  .btn-box{
    //margin-top: 40px;
  }
  .btn-txt{
    font-size: 30px;background: #FDD80D;border-color: #FDD80D;color: #333333;
  }
}
</style>
